import React, { useState } from 'react';
import { LESSONS_CONFIG } from '../lessons';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Exercise from '../components/Exercise/Index';
import HomePage from './HomePage';
import { useParams } from 'react-router-dom';
import BackButton from '../components/BackButton';
import { useEffect } from 'react';

// Main App Component
const ContentView = () => {
  const { id ,category} = useParams();
  const navigate = useNavigate();
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  if (!id || !LESSONS_CONFIG || !LESSONS_CONFIG[id]) {
    return <div>الدرس غير متوفر</div>;
  }

  const lesson = LESSONS_CONFIG[id];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-500 to-purple-700 p-3 sm:p-5 mb-6" dir="rtl">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-8 shadow-2xl mb-6">
        <BackButton category={category}/>

        {lesson.exercises.map((exercise) => (
          <Exercise key={exercise.id} exercise={exercise} />
        ))}
      </div>
    </div>
  );
};

export default ContentView;